import {Component, Input, OnInit} from '@angular/core';
import {TestExecution} from '../../../data/models/execution/test-execution';

@Component({
  selector: 'app-test-execution-finish',
  templateUrl: './test-execution-finish.component.html',
  styleUrls: ['./test-execution-finish.component.css']
})
export class TestExecutionFinishComponent implements OnInit {

  @Input() testExecution!: TestExecution;
  @Input() testType!: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
